import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { MaterialItemCategoryActionTypes } from "./MaterialItemCategory.type";

export function* fetchAllMaterialItemCategorys(action: any): any {
  try {
 let query = "";
    if (action.payload) {
      const keys = Object.keys(action.payload);
      query = keys.map((key) => `${key}=${action.payload[key]}`).join("&");
    }
    const response = yield axios.get(`${API_BASE_URI}/material-item-category?${query}`);
    yield put({
      type: MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type:  MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY_FAILURE,
      payload: error,
    });
  }
}

export function* fetchPagedMaterialItemCategorys(action: any): any {
    try {
   let query = "";
      if (action.payload) {
        const keys = Object.keys(action.payload);
        query = keys.map((key) => `${key}=${action.payload[key]}`).join("&");
      }
      const response = yield axios.get(`${API_BASE_URI}/material-item-category?${query}`);
      yield put({
        type:  MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({
        type:  MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY_FAILURE,
        payload: error,
      });
    }
  }

export function* fetchOneMaterialItemCategorys(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/material-item-category/${action.payload}`
    );
    yield put({
      type:  MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllMaterialItemCategorys() {
  yield takeLatest( MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY, fetchAllMaterialItemCategorys);
}

export function* watcherFetchPagedMaterialItemCategorys() {
    yield takeLatest(MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY, fetchPagedMaterialItemCategorys);
  }

export function* watcherFetchOneMaterialItemCategorys() {
  yield takeLatest(MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY, fetchOneMaterialItemCategorys);
}
